import NavigationHeader from 'components/molecules/navigation-header';
import ActionTimeManagementFilters from 'components/templates/action-time-management-tool/filters';
import ActionTimeManagementToolTable from 'components/templates/action-time-management-tool/table';
import { useTranslation } from 'react-i18next';

const ActionTimeManagementTool = () => {
  const { t } = useTranslation();

  return (
    <>
      <NavigationHeader
        title={t('actionTimesManagement.actionTimeManagement')}
      />
      <ActionTimeManagementFilters />
      <ActionTimeManagementToolTable />
    </>
  );
};

export default ActionTimeManagementTool;
